<template>
    <b-modal v-model="showModal" size="xl" @hidden="cancelar" button-size="md" hide-footer :title="prefix + title">
        <HistoricoLotacaoList :item="item"></HistoricoLotacaoList>

        <b-form-row>
            <div class="col-6"></div>
            <b-button pill style="height: 30px" @click="cancelar" size="sm" variant="danger">
                <div>
                    <b-icon icon="x-circle" />
                </div>
            </b-button>

        </b-form-row>
    </b-modal>
</template>

<script>

import HistoricoLotacaoList from '@/modules/patrimonio/historicolotacao/HistoricoLotacaoList.vue';

export default {
    name: "ModalHistoricoLotacaoList",
    components: {
        HistoricoLotacaoList,

    },
    props: {
        item: Object,
        title: { type: String, default: " > Histórico Tombamento" },
        prefix: { type: String, default: "" },
    },
    data() {
        return {
            showModal: true,

        }
    },
    methods: {
        cancelar() {
            this.showModal = false;
            this.$emit('fecharModal');
        },

    }
}

</script>